export default "__VITE_ASSET__NAuL9pKm__";